// import React, { useEffect, useState } from "react";
// import { getAllUrls } from "../api";

// const API_BASE_URL =
//   process.env.REACT_APP_BACKEND_URL || "http://localhost:5001/api";

// const UrlList = () => {
//   const [urls, setUrls] = useState([]);

//   useEffect(() => {
//     const fetchUrls = async () => {
//       const data = await getAllUrls();
//       setUrls(data);
//     };
//     fetchUrls();
//   }, []);

//   return (
//     <div>
//       <h3>URLs Acortadas</h3>
//       <ul>
//         {urls.map((url) => (
//           <li key={url._id}>
//             <a
//               href={url.shortUrl}
//               target="_blank"
//               rel="noopener noreferrer"
//             >{`${API_BASE_URL}/${url.shortId}`}</a>{" "}
//             - {url.originalUrl}
//           </li>
//         ))}
//       </ul>
//     </div>
//   );
// };

// export default UrlList;

// import React, { useEffect, useState } from "react";
// import { getAllUrls } from "../api";

// const API_BASE_URL = process.env.REACT_APP_BACKEND_URL || "http://localhost:5001";

// const UrlList = () => {
//     const [urls, setUrls] = useState([]);
//     const [loading, setLoading] = useState(true);

//     useEffect(() => {
//         const fetchUrls = async () => {
//             try {
//                 const data = await getAllUrls();
//                 console.log("🔍 Datos recibidos:", data);
//                 setUrls(Array.isArray(data) ? data : []);
//             } catch (error) {
//                 console.error("❌ Error obteniendo URLs:", error);
//                 setUrls([]);
//             } finally {
//                 setLoading(false);
//             }
//         };
//         fetchUrls();
//     }, []);

//     return (
//         <div className="max-w-5xl mx-auto mt-8 px-6 py-6 bg-gray-900 text-white shadow-2xl rounded-xl">
//             <h3 className="text-3xl font-extrabold text-center mb-6 text-blue-400">🔗 URLs Acortadas</h3>

//             {loading ? (
//                 <p className="text-center text-gray-400 mt-4">Cargando URLs...</p>
//             ) : urls.length === 0 ? (
//                 <p className="text-center text-gray-400 mt-4">No hay URLs disponibles</p>
//             ) : (
//                 <div className="overflow-hidden">
//                     <ul className="space-y-6">
//                         {urls.map((url) => {
//                             const shortUrl = `${API_BASE_URL}/${url.shortId}`;

//                             return (
//                                 <li 
//                                     key={url._id} 
//                                     className="p-5 bg-gray-800 shadow-md rounded-lg flex flex-col md:flex-row items-center md:items-stretch justify-between gap-6 border border-gray-700 hover:border-blue-400 transition"
//                                 >
//                                     {/* Contenedor del destino con scroll horizontal interno */}
//                                     <div className="flex-1 text-center md:text-left">
//                                         <p className="text-sm text-gray-400 mb-1">Destino:</p>
//                                         <div className="bg-gray-700 p-3 rounded-lg max-w-full overflow-x-auto whitespace-nowrap scrollbar-thin scrollbar-thumb-blue-500 scrollbar-track-gray-700"
//                                             style={{ maxWidth: "200px", overflowX: "auto", padding: "8px", borderRadius: "10px" }}
//                                         >
//                                             <a 
//                                                 href={url.originalUrl} 
//                                                 target="_blank" 
//                                                 rel="noopener noreferrer"
//                                                 className="text-blue-400 hover:underline inline-block"
//                                             >
//                                                 {url.originalUrl}
//                                             </a>
//                                         </div>
//                                     </div>

//                                     {/* Contenedor de la URL acortada con scroll horizontal interno */}
//                                     <div className="flex-1 text-center md:text-left">
//                                         <p className="text-sm text-gray-400 mb-1">URL Acortada:</p>
//                                         <div className="bg-gray-700 p-3 rounded-lg max-w-full overflow-x-auto whitespace-nowrap scrollbar-thin scrollbar-thumb-green-500 scrollbar-track-gray-700"
//                                             style={{ maxWidth: "250px", overflowX: "auto", padding: "8px", borderRadius: "10px" }}
//                                         >
//                                             <a 
//                                                 href={shortUrl} 
//                                                 target="_blank" 
//                                                 rel="noopener noreferrer"
//                                                 className="text-green-400 hover:underline inline-block"
//                                             >
//                                                 {shortUrl}
//                                             </a>
//                                         </div>
//                                     </div>

//                                     {/* Botón de copiar futurista */}
//                                     <button
//                                         onClick={() => {
//                                             navigator.clipboard.writeText(shortUrl);
//                                             alert(`✅ URL copiada: ${shortUrl}`);
//                                         }}
//                                         className="bg-gradient-to-r from-blue-500 to-green-500 text-white px-6 py-2 rounded-lg hover:scale-105 transition transform shadow-lg"
//                                     >
//                                         Copiar
//                                     </button>
//                                 </li>
//                             );
//                         })}
//                     </ul>
//                 </div>
//             )}
//         </div>
//     );
// };

// export default UrlList;


import React, { useEffect, useState } from "react";
import { getAllUrls } from "../api";

const API_BASE_URL = process.env.REACT_APP_BACKEND_URL || "http://localhost:5001";

const UrlList = () => {
    const [urls, setUrls] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchUrls = async () => {
            try {
                const data = await getAllUrls();
                setUrls(Array.isArray(data) ? data : []);
            } catch (error) {
                console.error("❌ Error obteniendo URLs:", error);
                setUrls([]);
            } finally {
                setLoading(false);
            }
        };
        fetchUrls();
    }, []);

    return (
        <div className="w-full max-w-4xl bg-gray-900 text-white p-6 rounded-xl shadow-lg">
            <h3 className="text-2xl font-bold text-center text-blue-400 mb-6">🔗 URLs Acortadas</h3>

            {loading ? (
                <p className="text-center text-gray-400">Cargando URLs...</p>
            ) : urls.length === 0 ? (
                <p className="text-center text-gray-400">No hay URLs disponibles</p>
            ) : (
                <ul className="space-y-6">
                    {urls.map((url) => {
                        const shortUrl = `${API_BASE_URL}/${url.shortId}`;

                        return (
                            <li key={url._id} className="p-5 bg-gray-800 shadow-md rounded-lg flex flex-col md:flex-row items-center justify-between gap-6 border border-gray-700 hover:border-blue-500 transition">
                                
                                {/* Destino */}
                                <div className="flex-1 text-center md:text-left">
                                    <p className="text-sm text-gray-400 mb-1">Destino:</p>
                                    <div className="bg-gray-700 p-3 rounded-lg max-w-full w-[250px] overflow-x-auto whitespace-nowrap scrollbar-thin scrollbar-thumb-blue-500 scrollbar-track-gray-700">
                                        <a href={url.originalUrl} target="_blank" rel="noopener noreferrer"
                                            className="text-blue-400 hover:underline inline-block">
                                            {url.originalUrl}
                                        </a>
                                    </div>
                                </div>

                                {/* URL Acortada (Corrección aplicada) */}
                                <div className="flex-1 text-center md:text-left">
                                    <p className="text-sm text-gray-400 mb-1">URL Acortada:</p>
                                    <div className="bg-gray-700 p-3 rounded-lg max-w-full w-[250px] overflow-x-auto whitespace-nowrap scrollbar-thin scrollbar-thumb-green-500 scrollbar-track-gray-700">
                                        <a href={shortUrl} target="_blank" rel="noopener noreferrer"
                                            className="text-green-400 hover:underline inline-block">
                                            {shortUrl}
                                        </a>
                                    </div>
                                </div>

                                {/* Botón de Copiar */}
                                <button
                                    onClick={() => {
                                        navigator.clipboard.writeText(shortUrl);
                                        alert(`✅ URL copiada: ${shortUrl}`);
                                    }}
                                    className="bg-gradient-to-r from-green-500 to-blue-500 text-white px-6 py-2 rounded-lg hover:scale-105 hover:shadow-lg transition transform shadow-md">
                                    Copiar
                                </button>
                            </li>
                        );
                    })}
                </ul>
            )}
        </div>
    );
};

export default UrlList;
